/**
 * /dashboard/accounting/money/receipts — Receipts list (G_ACC6c).
 *
 * Standalone list with full filter bar. Mirrors the Sales tab UX.
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/money/receipts/page.tsx.
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { ReceiptList } from "@/components/accounting/receipt-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/accounting/money/receipts/")({
  component: ReceiptsListRoute,
});

function ReceiptsListRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <AccountingModuleShell
      title="Receipts"
      description="Customer payments received and applied to invoices."
      actions={
        <>
          <Button asChild className="gap-1.5">
            <Link to="/app/$tenantSlug/accounting/money/receipts/new" params={{ tenantSlug }}>
              <Plus aria-hidden className="h-4 w-4" />
              New Receipt
            </Link>
          </Button>
        </>
      }
    >
      <ReceiptList />
    </AccountingModuleShell>
  );
}
